"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteTemplateType = exports.AvailabilityOptionsType = exports.SalesforceUserType = void 0;
var SalesforceUserType;
(function (SalesforceUserType) {
    SalesforceUserType["USER"] = "User";
    SalesforceUserType["LEAD"] = "Lead";
    SalesforceUserType["CONTACT"] = "Contact";
    SalesforceUserType["RESOURCE"] = "ResourcePool__c";
})(SalesforceUserType = exports.SalesforceUserType || (exports.SalesforceUserType = {}));
var AvailabilityOptionsType;
(function (AvailabilityOptionsType) {
    AvailabilityOptionsType["OPEN"] = "OPEN";
    AvailabilityOptionsType["CUSTOM"] = "CUSTOM";
    AvailabilityOptionsType["ROLLING_WINDOW"] = "ROLLING_WINDOW";
    AvailabilityOptionsType["DATE_RANGE"] = "DATE_RANGE";
    AvailabilityOptionsType["TRAVEL_TIME_GAP"] = "TRAVEL_TIME_GAP";
})(AvailabilityOptionsType = exports.AvailabilityOptionsType || (exports.AvailabilityOptionsType = {}));
var InviteTemplateType;
(function (InviteTemplateType) {
    InviteTemplateType["SALESFORCE_OBJECTS"] = "SALESFORCE_OBJECTS";
    InviteTemplateType["INVITE_LINKS_TAB"] = "INVITE_LINKS_TAB";
})(InviteTemplateType = exports.InviteTemplateType || (exports.InviteTemplateType = {}));
